import { render, staticRenderFns } from "./EditVillage.vue?vue&type=template&id=f5e4d8e6"
import script from "./EditVillage.vue?vue&type=script&lang=js"
export * from "./EditVillage.vue?vue&type=script&lang=js"
import style0 from "./EditVillage.vue?vue&type=style&index=0&id=f5e4d8e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports